import { DefaultIconProps } from './types';
import { CHEVRON_DOWN_YELLOW_ICON_URL } from './urls';

export const ChevronDownYellowIcon = ({ className, ...props }: DefaultIconProps) => (
  <img
    className={className}
    src={CHEVRON_DOWN_YELLOW_ICON_URL}
    alt="chevron-down-yellow"
    {...props}
  />
);
